import React from 'react'
import { DefaultCellContentWrapper } from 'view/components/datagrid/renderers'
import { Locale, Translation } from 'locale'
import { TextFlagButton } from 'view/components/buttons'
import { TextFlagState } from 'view/components/buttons/TextFlagButton'

interface OnOffButtonsProps {
  onLabel: Translation
  offLabel: Translation
  on: boolean
  onChange: (enabled: boolean) => void
  disabled?: boolean
}

export class OnOffButtons extends React.Component<OnOffButtonsProps> {
  render() {
    const { onLabel, offLabel, disabled } = this.props

    return (
      <DefaultCellContentWrapper>
        <TextFlagButton
          dataTestId={'OnOffButtons-TextFlagButton-OnLabel'}
          state={this.getOnLabelState()}
          onClick={this.onOn}
          disabled={disabled}>
          {Locale.translate(onLabel)}
        </TextFlagButton>
        <TextFlagButton
          dataTestId={'OnOffButtons-TextFlagButton-OffLabel'}
          state={this.getOffLabelState()}
          onClick={this.onOff}
          disabled={disabled}>
          {Locale.translate(offLabel)}
        </TextFlagButton>
      </DefaultCellContentWrapper>
    )
  }

  private getOnLabelState() {
    const { on } = this.props
    return on ? TextFlagState.On : TextFlagState.Off
  }

  private getOffLabelState() {
    const { on } = this.props
    return on ? TextFlagState.Off : TextFlagState.On
  }

  private onOn = () => {
    const { onChange } = this.props
    onChange(true)
  }

  private onOff = () => {
    const { onChange } = this.props
    onChange(false)
  }
}
